import { Card, Empty, Image, Space } from 'antd'
import { useTranslation } from 'react-i18next'

import type { ReturnRoot } from '@repo/sdk'

import { FALLBACK_IMAGE } from '../../components/ThumbnailImage'

interface ReturnImagesCardProps {
  returnData: ReturnRoot
}

export function ReturnImagesCard({ returnData }: ReturnImagesCardProps) {
  const { t } = useTranslation()
  const images = returnData.images ?? []

  return (
    <Card title={t('pages.returns.returnImages')} bordered>
      {images.length === 0 ? (
        <Empty description={t('pages.returns.noImages')} image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <Image.PreviewGroup>
          <Space wrap>
            {images.map((url, index) => (
              <Image
                key={`return-image-${String(index)}`}
                src={url}
                width={120}
                height={120}
                fallback={FALLBACK_IMAGE}
                style={{ objectFit: 'cover', borderRadius: 4 }}
              />
            ))}
          </Space>
        </Image.PreviewGroup>
      )}
    </Card>
  )
}
